<template>
  <header id="lm-header">
    <div class="navbar-custom">
      <transition name="fade" appear>
        <div class="app-search d-none d-xl-block">
          <div class="input-group d-none">
            <input type="text" class="form-control" :placeholder="$t('Search')">
            <span class="mdi mdi-magnify"></span>
            <div class="input-group-append">
              <button class="btn btn-primary" type="submit">{{ $t('Search')}}</button>
            </div>
          </div>
        </div>
      </transition>
      <button class="button-menu-mobile open-left disable-btn d-xl-none" @click="mutationIsOpen">
          <i class="mdi mdi-menu"></i>
      </button>
      <b-dropdown id="ddown-header" variant="transparent" no-caret class="m-0 p-0">
        <template slot="button-content">
          <div class="account-user-avatar">
              <img :src="avatar" alt="user-image" class="rounded-circle">
          </div>
          <div class="wrapperUserInfo d-none d-xl-block">
              <span class="account-user-name">{{ username }}</span>
              <span class="account-position">{{ user.rol }}</span>
          </div>
        </template>
        <b-dropdown-header tag="div" class="noti-title">
              <h6 class="text-overflow m-0">{{ $t('hello') }}</h6>
        </b-dropdown-header>
        <b-dropdown-item to="/user-profile">
          <i class="mdi mdi-account-circle"></i>
          <span>{{ $t('my_profile') }}</span>
        </b-dropdown-item>
        <!-- <b-dropdown-item>
          <i class="mdi mdi-account-settings"></i>
          <span>Settings</span>
        </b-dropdown-item>
        <b-dropdown-item>
          <i class="mdi mdi-lifebuoy"></i>
          <span>Support</span>
        </b-dropdown-item>
        <b-dropdown-item>
          <i class="mdi mdi-lock-outline"></i>
          <span>Lock Screen</span>
        </b-dropdown-item> -->
        <b-dropdown-item @click="logout()">
          <i class="mdi mdi-logout"></i>
          <span>{{ $t('Logout') }}</span>
        </b-dropdown-item>
      </b-dropdown>
      <b-dropdown id="notification-header" right variant="transparent" no-caret class="m-0 p-0">
        <template slot="button-content">
            <i class="dripicons-bell noti-icon"></i>
            <span class="noti-icon-badge" v-if="notificationUnread"></span>
        </template>
        <b-dropdown-header tag="div" class="noti-title">
          <h5 class="m-0">
              <span class="float-right">
                  <a href="javascript: void(0);" class="text-dark">
                      <small>Limpiar</small>
                  </a>
              </span>Notificaciones
          </h5>
        </b-dropdown-header>
        <!-- <div class="wrapper-dropdown-item">
          <b-dropdown-item v-for="(notify, index) in notifications" :key="index" class="notify-item">
            <div class="notify-icon bg-info">
                <i class="mdi mdi-heart"></i>
            </div>
            <p class="notify-details">Carlos Crouch liked
                <b>Admin</b>
                <small class="text-muted">13 days ago</small>
            </p>
          </b-dropdown-item>
        </div> -->
        <!-- <router-link to="" class="dropdown-item text-center text-primary notify-item notify-all">
          View All
        </router-link> -->
      </b-dropdown>
    </div>
  </header>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  data () {
    return {
      user: {
        rol: 'admin'
      },
      notifications: [{}, {}],
      notificationUnread: false
    }
  },
  computed: {
    ...mapState('session', ['avatar', 'username'])
  },
  methods: {
    logout () {
      this.$store.dispatch('session/logout')
        .then(() => {
          // navigate to the home route
          this.$router.replace('/login')
        })
    },
    ...mapMutations('menu', ['mutationIsOpen'])
  }
}
</script>

<style lang="sass" scoped>
  #lm-header
    .navbar-custom
      padding: 0 30px
      background-color: #fff
      box-shadow: 0 0 35px 0 rgba(154,161,171,.15)
      min-height: 70px
      @media(max-width: $xl)
        padding: 0 10px
      .button-menu-mobile
        border: none
        color: #313a46
        height: 70px
        line-height: 70px
        width: 60px
        background-color: transparent
        font-size: 24px
        cursor: pointer
        float: left
        &:focus
          outline: none
      #notification-header
        float: right
        .notify-all
          font-size: 14px
          color: $primaryThemeColor
          padding: 10px 20px
          &:hover
            text-decoration: none
            background-color: #f8f9fa
            color: #4250f2
        .noti-icon-badge
          display: inline-block
          position: absolute
          top: 16px
          right: 5px
          border-radius: 50%
          height: 7px
          width: 7px
          background-color: #fa5c7c
        .noti-icon
          font-size: 22px
          vertical-align: middle
          line-height: 70px
        .dropdown-menu
          width: 320px
        .noti-title
          background-color: #fff
          padding: 15px 20px
          h5
            font-size: 15px
          small
            font-size: 12px
        .wrapper-dropdown-item
          max-height: 230px
          overflow: auto
          .notify-item
            padding: 10px 20px
            &:hover
              background: #f8f9fa
            .notify-icon
              float: left
              height: 36px
              width: 36px
              line-height: 36px
              text-align: center
              margin-right: 10px
              border-radius: 50%
              color: #fff
              i
                margin: 0
            .notify-details
              margin-bottom: 0
              overflow: hidden
              margin-left: 45px
              text-overflow: ellipsis
              white-space: nowrap
              font-size: 14px
              b
                font-weight: 500
              small
                display: block
                font-size: 12px
      #ddown-header
        color: $mutedFontThemeColor
        min-width: 32px
        display: block
        margin: 0 8px
        text-align: left !important
        position: relative
        background-color: #fafbfd
        border: 1px solid #f1f3fa
        border-width: 0 1px
        min-height: 70px
        float: right
        padding: 5px 20px
        .account-user-avatar
          float: left
          img
            max-width: 32px
            max-height: 32px
        .wrapperUserInfo
          text-align: left
          padding-left: 10px
          float: left
          .account-user-name
            font-weight: 600
            color: $mutedFontThemeColor
            font-size: 14px
            display: block
            white-space: initial
          .account-position
            display: block
            font-size: 12px
            margin-top: -3px
            color: $mutedFontThemeColor
            white-space: initial
      .dropdown-menu
        .dropdown-item
          padding: 7px 20px
          display: block
          width: 100%
          clear: both
          font-weight: 400
          color: $primaryFontThemeColor
          text-align: inherit
          white-space: nowrap
          background-color: transparent
          border: 0
          i
            vertical-align: middle
            margin-right: 5px
            font-size: 14px
          span
            font-size: 14px
            vertical-align: middle
      .dropdown-header
        display: block
        padding: .25rem 1.5rem
        margin-bottom: 0
        font-size: .875rem
        color: inherit
        white-space: nowrap
        &.noti-title
          padding: 15px 20px
          h6
            font-size: 12px
      .app-search
        padding: 16px 0
        overflow: hidden
        float: left
        button
          font-size: 14px
        form
          max-width: 320px
          .input-group
            position: relative
            display: flex
            flex-wrap: wrap
            align-items: stretch
            width: 100%
        .form-control
          border: none
          height: 38px
          padding-left: 40px
          padding-right: 20px
          background-color: #f1f3fa
          box-shadow: none
          &::-webkit-input-placeholder
            color: #c1c1c1
            font-size: 14px
        .mdi-magnify
          position: absolute
          z-index: 10
          font-size: 20px
          line-height: 38px
          left: 10px
        .input-group-append
          margin-left: 0
          z-index: 4
</style>
